var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurstModeSolid = function SvgBurstModeSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    fillRule: "evenodd",
    d: "M1.4 19V5h1.2v14H1.4Zm4 0V5h1.2v14H5.4Zm4-12.9a.7.7 0 0 1 .7-.7h11.8a.7.7 0 0 1 .7.7v11.8a.7.7 0 0 1-.7.7H10.1a.7.7 0 0 1-.7-.7V6.1Zm5.8 5.9L12 16h8l-2-2.546-.857 1.091L15.2 12Z",
    clipRule: "evenodd"
  })));
};
export default SvgBurstModeSolid;